import { j as e } from "../../../../node_modules/react/jsx-runtime.js";
import { useRef as M, useState as p, useEffect as P } from "react";
import { clsx as j } from "../../../../node_modules/clsx/dist/clsx.m.js";
import v from "../../Icon/Icon.js";
import { FieldLabel as Q } from "../components/FieldLabel/FieldLabel.js";
import U from "../components/FieldHelperText/FieldHelperText.js";
import i from "./styles.module.scss.js";
import W from "../../Tooltip/Tooltip.js";
import T from "../../Button/Button.js";
const ie = ({
  label: g,
  optionalLabel: w,
  required: R,
  labelIconTooltip: C,
  helperTextIcon: I,
  helperTextIconTooltip: V,
  placeholder: z,
  value: l,
  type: B = "text",
  size: h = "regular",
  leadingIcon: u,
  leadingIconTooltip: y,
  helperText: N = "",
  status: k,
  disabled: r = !1,
  ref: D,
  testId: H,
  minWidth: K,
  maxWidth: L,
  direction: O,
  autoComplete: q = "off",
  readOnly: a = !1,
  onChange: d,
  onSubmit: x,
  ...A
}) => {
  const s = M(null), [m, c] = p(!1), [G, f] = p(l ?? ""), [F, o] = p(l ?? ""), J = (t) => {
    o(t.target.value), d == null || d(t.target.value);
  };
  return P(() => {
    o(l ?? "");
  }, [l]), /* @__PURE__ */ e.jsxs(
    "div",
    {
      className: j(i.fieldContainer, {
        "opacity-disabled": r
      }),
      style: { minWidth: K, maxWidth: L, direction: O },
      children: [
        g && /* @__PURE__ */ e.jsx(
          Q,
          {
            label: g,
            optionalLabel: w,
            required: R,
            disabled: r,
            tooltipText: C,
            size: h,
            withTextField: !0
          }
        ),
        /* @__PURE__ */ e.jsxs(
          "div",
          {
            ref: D,
            className: j(i.inlineInput, i[h], {
              [i.textFilled]: !!l || F,
              [i.readOnly]: a
            }),
            "aria-disabled": r,
            "data-destructive": k === "destructive",
            children: [
              u && (!r && y ? /* @__PURE__ */ e.jsx(
                W,
                {
                  trigger: /* @__PURE__ */ e.jsx("div", { className: i.leadingIcon, children: /* @__PURE__ */ e.jsx(v, { name: u }) }),
                  title: y
                }
              ) : /* @__PURE__ */ e.jsx("div", { className: i.leadingIcon, children: /* @__PURE__ */ e.jsx(v, { name: u }) })),
              /* @__PURE__ */ e.jsx(
                "input",
                {
                  ...A,
                  type: B,
                  placeholder: z,
                  value: F,
                  onChange: J,
                  disabled: r || !m,
                  "data-testid": H,
                  ref: s,
                  autoComplete: q,
                  readOnly: a,
                  className: j({ [i.readOnly]: a })
                }
              ),
              !m && !r && !a && /* @__PURE__ */ e.jsx(
                "div",
                {
                  className: i.editIcon,
                  onClick: () => {
                    var t;
                    c(!0), f(((t = s.current) == null ? void 0 : t.value) ?? "");
                  },
                  onKeyDown: (t) => {
                    var n;
                    t.key === "Enter" && (c(!0), f(((n = s.current) == null ? void 0 : n.value) ?? ""));
                  },
                  role: "button",
                  tabIndex: 0,
                  children: /* @__PURE__ */ e.jsx(v, { name: "edit-05" })
                }
              ),
              m && /* @__PURE__ */ e.jsxs("div", { className: "flex items-center gap-050 p-100", children: [
                /* @__PURE__ */ e.jsx(
                  T,
                  {
                    testId: "x-close-input",
                    iconOnly: !0,
                    leadingIcon: "x",
                    variant: "tinted",
                    color: "danger",
                    size: "small",
                    onClick: () => {
                      c(!1), o(G);
                    }
                  }
                ),
                /* @__PURE__ */ e.jsx(
                  T,
                  {
                    testId: "check-save-input",
                    iconOnly: !0,
                    leadingIcon: "check",
                    variant: "tinted",
                    color: "primary",
                    size: "small",
                    onClick: () => {
                      var t, n, E;
                      f(((t = s.current) == null ? void 0 : t.value) ?? ""), o(((n = s.current) == null ? void 0 : n.value) ?? ""), c(!1), x == null || x(((E = s.current) == null ? void 0 : E.value) ?? "");
                    }
                  }
                )
              ] })
            ]
          }
        ),
        (N || I) && /* @__PURE__ */ e.jsx(
          U,
          {
            label: N,
            disabled: r,
            icon: I,
            tooltipText: V,
            status: k,
            withTextField: !0
          }
        )
      ]
    }
  );
};
export {
  ie as default
};
//# sourceMappingURL=InlineField.js.map
